import { defineMessages } from 'react-intl'

const scope = `procurify.modules.expense.features.correct-expense-item-account-codes.CorrectExpenseItemAccountCodesPresenter`

export default defineMessages({
  errorTitle: {
    id: `${scope}.errorTitle`,
    defaultMessage: 'Error',
  },
  saveErrorMessage: {
    id: `${scope}.saveErrorMessage`,
    defaultMessage: 'Failed to update expense item',
  },
  siblingsFetchErrorMessage: {
    id: `${scope}.siblingsFetchErrorMessage`,
    defaultMessage: 'Failed to fetch the other items in this expense report',
  },
  budgetPeriodFetchErrorMessage: {
    id: `${scope}.budgetPeriodFetchErrorMessage`,
    defaultMessage: 'Failed to fetch the budget period for this account',
  },
})
